import { inject, Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ErrorMessages, ErrorType, ErrorTypes, FileValidationErrorModel, InputItemBaseModel, InputItemModel } from '@libs/form/models';
import { ErrorTokenReplacer } from './error-token-replacer';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageFormatter {
  private readonly tokenReplacer: ErrorTokenReplacer = inject(ErrorTokenReplacer);

  public formatMessage(control: AbstractControl, data: InputItemModel): string {
    if (!control.errors) {
      return '';
    }

    const type: ErrorType = this.getType(control);
    const message: string = this.getMessage(type, data, control.errors);

    return this.tokenReplacer.replaceTokens(message, data);
  }

  private getType(control: AbstractControl): ErrorType {
    for (const type of ErrorTypes) {
      if (control.hasError(type)) {
        return type;
      }
    }

    return 'unknown';
  }

  private getMessage(type: ErrorType, data: InputItemBaseModel, validationErrors: ValidationErrors): string {
    if (type === 'pattern') {
      return data.attributes?.title ?? ErrorMessages[type];
    }

    if (type === 'custom' && typeof validationErrors['custom'] === 'string') {
      return validationErrors['custom'];
    }

    if (type === 'file' && Array.isArray(validationErrors['file'])) {
      const errors: FileValidationErrorModel[] = validationErrors['file'] as FileValidationErrorModel[];

      if (errors.length > 1) {
        return ErrorMessages.file;
      }

      if (errors[0].message) {
        return errors[0].message;
      }

      if (errors[0].maxSize) {
        return ErrorMessages.fileMaxSize;
      }

      if (errors[0].types) {
        return ErrorMessages.fileType;
      }
    }

    return ErrorMessages[type];
  }
}
